import { cloneDeep, isEqual } from 'lodash'

export class BaseModel<T> {
    protected collectionName = ''

    constructor(
        public id: string,
    ) {}

    get resourceIdentifier() {
        return `/api/v1/${this.collectionName}/${this.id}`
    }

    update(other: BaseModel<T>) {
        if (this.id !== other.id) {
            return
        }

        const baseKeys = ['id', 'collectionName']
        const keys = Object.keys(this).filter(key => !baseKeys.includes(key))

        keys.forEach(key => {
            this[key] = other[key]
        })
    }

    clone(): T {
        return cloneDeep<T>(this as any)
    }

    isEqual(other: T): boolean {
        return isEqual(this, other)
    }
}
